<template>
  <v-chip :color="color" :size="size" :style="dynamicStyle" class="justify-center">
    <v-icon v-if="prependIcon" :icon="prependIcon"></v-icon>
    <span class="truncated-chip">
      {{ text }}
    </span>
    <v-icon v-if="appendIcon" :icon="appendIcon" class="ms-1"></v-icon>
  </v-chip>
</template>

<script setup>
const props = defineProps({
  text: String,
  color: {
    type: String,
    default: "lime",
  },
  size: {
    type: String,
    default: "x-small",
  },
  appendIcon: String,
  prependIcon: String,
  borderColor: String
});

const dynamicStyle = computed(() => {
  const targetColor = props.borderColor || props.color;
  return {
    border: `1px solid rgb(var(--v-theme-${targetColor}3))`,
  };
});
</script>

<style scoped>
.truncated-chip {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  margin-top: 2px;
  max-width: 100%;
}
</style>
